import { useTranslation } from 'react-i18next'

const HolidayTipsHeader = () => {
  const { t } = useTranslation(['holiday-tips'])
  return (
    <div className="holiday-tips__header">
      <span className="holiday-tips__header-title">{t('holiday-tips:header.title')}</span>
      <span className="holiday-tips__header-subtitle">{t('holiday-tips:header.subtitle')}</span>
    </div>
  )
}

export default HolidayTipsHeader
